import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { TooltipProvider } from "./components/ui/tooltip";
import "./shared/i18n";
import { LaunchDarklyProvider } from "@/integrations/launch-darkly/LaunchDarklyProvider";

const root = ReactDOM.createRoot(document.getElementById("root")!);

const load = async () => {
  root.render(
    <React.StrictMode>
      <LaunchDarklyProvider>
        <TooltipProvider delayDuration={100}>
          <App />
        </TooltipProvider>
      </LaunchDarklyProvider>
    </React.StrictMode>,
  );
};

load().then();
